/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import accountHandlers from './account';
import endpointHandlers from './endpoint';
import validationHandlers from './validation';

/**
 * @ref https://mswjs.io/docs/network-behavior/rest
 * @ref https://mswjs.io/docs/network-behavior/graphql
 */
export const handlers = [...accountHandlers, ...endpointHandlers, ...validationHandlers];
